import type { Patient } from '@medplum/fhirtypes'
import { FacilityDiscovery } from './discovery/FacilityDiscovery'
import type { DiscoveryModality, FacilityForOrder } from './discovery/discoveryTypes'
import { OrderDeliveryStep } from './shared/OrderDeliveryStep'

type Props = {
  patient: Patient
  selectedFacilityId: string
  modality?: DiscoveryModality
  onSelectFacility: (organizationId: string, facility: FacilityForOrder | null) => void
  /** PD-1642 — the patient carries a printable requisition to any radiology location. */
  patientChoosesLocation: boolean
  onPatientChoosesLocation: () => void
  /** PD-1939 — fax delivery chosen; the form drops the patient-chosen location. */
  onFaxDelivery: () => void
  /** Fax delivery was chosen, even before a facility is picked (kept by the form). */
  faxDeliveryChosen: boolean
  canAdvance: boolean
  onBack: () => void
  onNext: () => void
  /** The fax the order currently goes to, so the facility search shows it on return. */
  selectedFacilityFax?: string
}

/** PD-1939 — radiology's "Order delivery" step, the same flow as the lab orders (PD-1929). */
export const RadiologyFacilityStep = ({
  patient,
  modality,
  onSelectFacility,
  selectedFacilityFax,
  ...step
}: Props) => (
  <OrderDeliveryStep
    {...step}
    placeName="radiology"
    renderDiscovery={(choosePatient) => (
      <FacilityDiscovery
        patient={patient}
        kind="radiology"
        selectedFacilityId={step.selectedFacilityId}
        modality={modality}
        onSelectFacility={onSelectFacility}
        onPatientChoosesLocation={choosePatient}
        selectedFacilityFax={selectedFacilityFax}
      />
    )}
  />
)
